<template>
  <div v-if="isLoggedIn && deliveryTime?.note" class="flex items-center gap-3 mx-3 sm:mx-0 p-3 bg-white-ice rounded-md">
    <van-icon :name="$publicPath('/images/truck.svg')" class="flip-icon-ltr" size="22"/>
    <div class="flex items-center flex-wrap">
      <p class="delivery-txt grow" v-html="deliveryTime?.note"/>
      <span v-if="deliveryTime?.show_cities" class="text-cerulean font-bold cursor-pointer"
            @click="openCityModal">: {{ deliveryTime?.city?.name }}<van-icon
          color="#00aee8" name="arrow-down"/></span>
      <span v-else class="text-cerulean font-bold cursor-pointer">: {{
          deliveryTime?.city?.name
        }}</span>
    </div>
    <cities-popup v-model="showCitiesPopup" v-model:cityId="cityId" @onSubmit="onSubmit"/>
  </div>
</template>

<script setup>
import {getEstimatedTime} from "@/plugins/API/review";
import CitiesPopup from "@/components/product/CitiesPopup.vue";
import {useAuthStore} from '@/store/auth'

const authStore = useAuthStore();
const {isLoggedIn} = storeToRefs(authStore)
const deliveryTime = ref({});
const cityId = ref('');
const showCitiesPopup = ref(false);
const {isLoading, mutateAsync} = getEstimatedTime();
const getDeliveryTime = () => {
  isLoggedIn.value && mutateAsync(cityId.value).then(({data}) => {
    deliveryTime.value = data.edt
  })
}

onMounted(() => {
  getDeliveryTime()
})
const openCityModal = () => {
  showCitiesPopup.value = true
}
const onSubmit = () => {
  getDeliveryTime()
}
</script>

<style scoped>
</style>